import { Input } from '@builder.io/sdk';

const imageField = <T extends string = 'image'>(name: T = 'image' as T, showIf?: string) =>
  ({
    name,
    type: 'object',
    subFields: [
      {
        name: 'file',
        type: 'cloudinaryImageEditor',
        helperText: 'Select or upload an image from the media library (Cloudinary).',
      },
      {
        name: 'alt',
        type: 'string',
        helperText: 'Descriptive alternative text for screen readers and SEO.',
      },
    ],
    showIf,
    helperText: 'Image object containing the uploaded file and optional alt text.',
  }) as const satisfies DeepReadonly<Input>;

export const richImageFields = [imageField('image')] as const satisfies DeepReadonly<Input[]>;

export type ImageConfig = GenerateBuilder<typeof richImageFields>;

export const imageConfig = {
  name: 'image',
  inputs: richImageFields,
};

export default imageField;
